var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fof-error"}},[_c('error-component',[_c('template',{slot:"title"},[_c('h1',[_vm._v("404 Error")])]),_vm._v(" "),_c('template',{slot:"subtitle"},[_c('h2',[_vm._v("Page not found")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('p',[_vm._v("\n        Missing a Partnership? Add a new Partnership by following the link below.\n      ")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afe9b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FOFError.vue
// module id = 7qhD
// module chunks = 1